import { COOKIE_SETTING } from 'components/alert/alert-cookie/const'

export const COOKIES_SETTING_FAQ = {
  header: COOKIE_SETTING,
  details: {
    key: 'COOKIES_FAQ_DETAILS',
    text: `Along with our partners we use trackers for the reasons below to store and
    retrieve info from your device. To manage cookies settings visit the link
    below:`,
  },
  button: {
    key: 'COOKIES_FAQ_MANAGE_BUTTON',
    text: 'Manage Cookies settings here',
  },
}

export default COOKIES_SETTING_FAQ
